export default {
    link_copied_to_clipboard: 'Link copiato negli appunti!',
    at: 'alle',
    open: 'Apri',
    close: 'Chiudi',
    apply: 'Applica',
    cancel: 'Annulla',
    search: 'Cerca',
    cancel_search: 'Annulla ricerca',
    edit_search: 'Modifica ricerca',
    erase: 'Cancella',
    back_to_results: 'Torna ai risultati',
    save: 'Salva',
    retry: 'Riprova',
    click_here: 'Clicca qui',
    copy: 'Copia',
    copied: 'Copiato',
    copied_coordinates: 'Coordinate copiate',
    copy_coordinates: 'Copia coordinate',
    copied_address: 'Indirizzo copiato',
    copy_address: 'Copia indirizzo',
    map_context: {
        route_from_here: 'Calcola un percorso da qui',
        route_to_here: 'Calcola un percorso fino a qui',
        find_near_vehicles: 'Trova veicoli nelle vicinanze',
        vehicles_history: 'Vedi lo storico dei veicoli',
        create_poi: 'Crea un nuovo POI qui'
    },
    invalid_coordinates: 'Impossibile aprire questa posizione',
    open_in_maps: 'Apri in Google Maps',
    reports: 'Report',
    notifications: 'Gestione notifiche',
    notification_management: {
        search_placeholder: 'Cerca una regola',
        search_scope: 'Dove cercare',
        search_everywhere: 'Ovunque',
        search_by_plate: 'Per targa',
        search_by_tag: 'Per tag',
        search_by_event_name: 'Per nome evento',
        event_filter: 'Filtra per evento',
        all_events: 'Tutti gli eventi',
        poi_entry: 'Ingresso da un POI',
        poi_exit: 'Uscita da un POI',
        channel_filter: 'Filtra per canale',
        all_channels: 'Tutti i canali',
        email: 'Email',
        sms: 'SMS',
        new_rule: 'Nuova regola',
        reset_filters: 'Resetta',
        all_destinations: 'Tutte le destinazioni',
        destination_filter: 'Filtra per destinazione',
        edit_rule: 'Modifica regola',
        clone_rule: 'Clona regola',
        copy_of: 'Copia di',
        unsaved_changes_title: 'Modifiche non salvate',
        unsaved_changes_message: 'Hai modifiche non salvate. Vuoi uscire e scartarle?',
        discard_changes: 'Esci senza salvare',
        continue_editing: 'Continua modifica',
        rule_form_subtitle: 'Configura evento, veicoli e canali di notifica.',
        rule_details: 'Dettagli della regola',
        rule_details_hint: 'Assegna un nome e scegli l’evento da monitorare.',
        rule_name: 'Nome della regola',
        rule_name_placeholder: 'Es. Ingresso mezzi in sede',
        monitored_event: 'Evento da monitorare',
        rule_language: 'Lingua della notifica',
        language_italian: 'Italiano',
        language_english: 'Inglese',
        event_not_supported: 'presto disponibile',
        event_not_supported_error: 'Seleziona un evento supportato dalle API.',
        target_vehicles: 'Veicoli interessati',
        target_vehicles_hint: 'Applica la regola alla flotta o a una selezione di veicoli.',
        whole_fleet: 'Tutta la flotta',
        whole_fleet_hint: 'La regola si applica a tutti i veicoli.',
        specific_vehicles: 'Veicoli specifici',
        specific_vehicles_hint: 'Seleziona per tag e/o per targa.',
        vehicle_tags: 'Tag veicolo',
        no_vehicle_tags: 'Non sono disponibili tag veicolo.',
        vehicle_plates: 'Targhe',
        select_vehicles: 'Seleziona una o più targhe',
        target_and_hint: 'Se selezioni sia tag sia targhe, i due criteri vengono applicati in AND.',
        event_parameters: 'Parametri dell’evento',
        event_parameters_hint: 'I parametri dipenderanno dall’evento selezionato.',
        pois_to_monitor: 'POI da controllare',
        select_pois: 'Seleziona uno o più POI',
        poi_categories_to_monitor: 'Categorie POI da controllare',
        select_poi_categories: 'Seleziona una o più categorie POI',
        stopped_after_hours: 'Notifica il veicolo fermo dopo',
        hours_unit: 'ore',
        hour_unit: 'ora',
        excluded_stop_pois: 'Non notificare la sosta nei seguenti POI',
        excluded_stop_poi_categories: 'Non notificare la sosta nelle seguenti categorie POI',
        notify_for_hours: 'Continua a notificare per',
        temperature_threshold: 'Notifica quando la temperatura supera',
        low_temperature_threshold: 'Notifica quando la temperatura scende sotto',
        minimum_notification_interval: 'Intervallo minimo tra due notifiche',
        minutes_unit: 'minuti',
        minute_unit: 'minuto',
        minimum_duration_hint: 'Durata minima: :duration',
        required_positive_number: 'Inserisci un valore maggiore di zero.',
        non_negative_number: 'Il valore non può essere negativo.',
        parameters_to_define:
            'La configurazione specifica di questo evento verrà aggiunta nel prossimo step.',
        select_event_first: 'Seleziona prima un evento',
        channels_recipients: 'Canali e destinatari',
        channels_recipients_hint: 'Attiva almeno un canale e specifica i relativi destinatari.',
        email_recipients_hint: 'Indirizzi email che riceveranno la notifica.',
        sms_recipients_hint: 'Numeri di telefono che riceveranno la notifica.',
        add_email_recipient: 'Inserisci un indirizzo email',
        add_sms_recipient: 'Inserisci un numero di telefono',
        add_recipient: 'Aggiungi',
        remove_recipient: 'Rimuovi destinatario',
        invalid_email_recipient: 'Inserisci un indirizzo email valido.',
        invalid_phone_recipient: 'Inserisci un numero di telefono valido.',
        duplicate_recipient: 'Questo destinatario è già presente.',
        required_field: 'Campo obbligatorio.',
        target_required: 'Seleziona almeno un tag o una targa.',
        channel_required: 'Attiva almeno un canale di notifica.',
        recipient_required: 'Inserisci almeno un destinatario.',
        views: 'Viste gestione notifiche',
        event_list: 'Lista regole eventi',
        category_event_list: 'Lista regole eventi per Categoria',
        name_event: 'Nome/Evento',
        applied_to: 'Applicata a',
        main_parameters: 'Parametri principali',
        channels: 'Canali',
        actions: 'Azioni',
        no_rules: 'Nessuna regola di notifica disponibile.',
        loading_rules: 'Caricamento delle regole di notifica…',
        load_rules_error: 'Impossibile caricare le regole di notifica.',
        create_rule_success: 'Regola di notifica creata correttamente.',
        create_rule_error: 'Impossibile creare la regola di notifica.',
        update_rule_success: 'Regola di notifica aggiornata correttamente.',
        update_rule_error: 'Impossibile aggiornare la regola di notifica.',
        delete_rule: 'Elimina regola',
        delete_rule_confirmation: 'Vuoi eliminare la regola “:name”?',
        delete_rule_success: 'Regola di notifica eliminata correttamente.',
        delete_rule_error: 'Impossibile eliminare la regola di notifica.',
        channel_enabled: 'acceso',
        channel_disabled: 'spento',
        recipient_total: ':count destinatario totale',
        recipients_total: ':count destinatari totali',
        language: 'Lingua'
    },
    notification_events: {
        categories: {
            poi: 'POI',
            vehicle_status: 'Stato veicolo',
            temperature: 'Temperatura',
            ignition: 'Accensione',
            doors: 'Porte',
            tachograph: 'Tachigrafo'
        },
        events: {
            poi_in: 'Ingresso in un POI',
            poi_out: 'Uscita da un POI',
            vehicle_stationary: 'Veicolo fermo',
            low_temperature: 'Temperatura sotto soglia',
            high_temperature: 'Temperatura sopra soglia',
            door_open: 'Apertura porta',
            poi_entry: 'Ingresso in un POI',
            poi_exit: 'Uscita da un POI',
            vehicle_stopped: 'Veicolo fermo',
            probe_temperature_threshold: 'Soglia temperatura sonda',
            vehicle_ignition_on: 'Accensione veicolo',
            vehicle_ignition_off: 'Spegnimento veicolo',
            door_opened: 'Apertura porta',
            door_closed: 'Chiusura porta',
            driver_card_inserted: 'Inserimento carta conducente'
        }
    },
    tachograph_activities: 'Attività cronotachigrafo',
    tachograph_activities_period_hint:
        'Visualizza le attività cronotachigrafo del veicolo per questo periodo:',
    select: 'Seleziona',
    selected: 'Selezionato',
    selected_plural: 'Selezionati',
    deselect: 'Deseleziona',
    select_multi_vehicles: 'Seleziona uno o più veicoli',
    include: 'Includi',
    exclude: 'Escludi',
    balanced: 'Equilibrato',
    input: 'Ingresso',
    output: 'Uscita',
    verified: 'Verificato',
    save_settings: 'Salva impostazioni',
    empty_search: 'Nessun risultato trovato',
    read_more: 'Leggi di più',
    details: 'Dettagli',
    actual: 'Attuale',
    residual_time: 'Tempo residuo',
    next: 'Prossimo',
    previous: 'Precedente',
    menu_open: 'Apri menu',
    hide: 'Nascondi',
    show: 'Mostra',
    none: 'Nessuno',
    none_alt: 'Nessuna',
    all: 'Tutti',
    all_alt: 'Tutte',
    default: 'Predefinito',
    settings: 'Impostazioni',
    vehicle_list_settings: 'Impostazioni lista veicoli',
    reset_settings: 'Resetta impostazioni',
    reset_settings_success: 'Impostazioni resettate con successo',
    settings_saving: 'Salvataggio impostazioni…',
    settings_save_error: 'Salvataggio impostazioni non riuscito: modifiche annullate',
    multiselect_default_value: {
        singular: 'Valore selezionato:',
        plural: 'Valori selezionati:'
    },
    available: 'Disponibile',
    unavailable: 'Non disponibile',
    not_available: 'Non disponibile',
    not_available_plural: 'Non disponibili',
    from: 'dal',
    to: 'al',
    of: 'di',
    yes: 'Si',
    no: 'No',
    minutes: 'Minuti',
    hours: 'Ore',
    hour: 'Ora',
    days: 'Giorni',
    day: 'Giorno',
    months: 'Mesi',
    month: 'Mese',
    years: 'Anni',
    year: 'Anno',
    days_names: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
    days_names_short: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    months_names: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre'
    ],
    months_names_short: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic'
    ],
    areas: 'Aree',
    area: 'Area',
    time: 'Tempo (min)',
    time_label: 'Tempo',
    cost: 'Costo',
    toll_cost: 'Costo pedaggio',
    km_cost: 'Costo al km',
    hourly_cost: 'Costo orario',
    working_cost: 'Costo uomo totale',
    total_cost: 'Costo totale',
    expire_date: 'Data di scadenza',
    start_date: 'Data di inizio',
    recap: 'Riepilogo',
    start: 'Inizio',
    starting_point: 'Partenza',
    end: 'Fine',
    finish_point: 'Arrivo',
    duration: 'Durata',
    distance: 'Distanza',
    daily_distance: 'Km percorsi giornalieri',
    distance_total: 'Distanza totale',
    gps_distance: 'Distanza (GPS)',
    distance_gps: 'Km percorsi giornalieri (GPS)',
    pause: 'Pausa',
    segment: 'Tratta',
    start_time: 'Ora di inizio',
    end_time: 'Ora di fine',
    service_time: 'Tempo di servizio',
    waypoint_load: 'Carico a bordo',
    state: 'Stato',
    driver_statuses: {
        nessuno_stato: 'Nessuno stato',
        carico: 'Carico',
        scarico: 'Scarico',
        aggancio_semirimorchio: 'aggancio semirimorchio',
        sgancio_semirimorchio: 'sgancio semirimorchio',
        rifornimento: 'rifornimento'
    },
    violated_plafond: 'Violazione plafond',
    traffic_delay: 'Ritardo traffico',
    company: 'Azienda',
    address: 'Indirizzo',
    position: 'Posizione',
    route: 'Percorso',
    filter_date: 'Filtra per data',
    warning: 'Attenzione',
    no_warning: 'Nessun avviso',
    alerts: 'Avvisi',
    trucks_with_alerts: 'Veicoli con avvisi',
    bluetooth_devices: 'Dispositivi Bluetooth',
    no_bluetooth_devices: 'Nessun dispositivo Bluetooth trovato',
    connected: 'Connesso',
    disconnected: 'Disconnesso',
    bluetooth_types: {
        temperature_probe: 'Sonda temperatura',
        door_probe: 'Sonda porta e temperatura'
    },
    back_to_home: 'Torna alla home',
    cerca: 'Cerca',
    search_vehicle: 'Cerca veicolo',
    filter: 'Filtra',
    filter_label: 'Filtro',
    filters_label: 'Filtri',
    filter_by: 'Filtra per',
    operations: 'Operazioni',
    filter_vehicles: 'Filtra veicoli',
    filter_applied: 'Filtro applicato con successo',
    filter_canceled: 'Filtro cancellato con successo',
    order_by: 'Ordina per',
    order: 'Ordine',
    ascending: 'Crescente',
    descending: 'Decrescente',
    value: 'Valore',
    select_filter: 'Seleziona filtro',
    sort_vehicles: 'Ordina veicoli',
    sort_for_alphanumeric: 'Alfabetico',
    sort_for_lastpoint: 'Cronologico',
    sort_for_company: 'Azienda',
    sort_for_activity: 'Attività',
    company_select: 'Seleziona azienda',
    no_companies_founded: 'Nessuna azienda trovata',
    multicompany: 'Filtra per azienda',
    no_vehicles_founded: 'Nessun veicolo trovato',
    print: 'Stampa',
    export: 'Esporta',
    print_recap: 'Stampa riepilogo',
    select_date: 'Seleziona una data',
    add: 'Aggiungi',
    add_new: 'Aggiungi nuovo',
    delete: 'Elimina',
    edit: 'Modifica',
    options: 'Opzioni',
    login: "Effettua l'accesso",
    logout: 'Esci',
    logout_confirm: 'Sei sicuro di voler uscire?',
    login_button: 'Accedi',
    connect: 'Connetti',
    logged: 'Connesso',
    manage: 'Gestisci',
    loading: 'Caricamento',
    loading_timeout: 'Errore di rete, per favore ricarica la pagina o riprova più tardi',
    go_back: 'Torna indietro',
    select_coordinates: 'Seleziona coordinate',
    other: 'Altro',
    options_general: 'Generali',
    options_language: 'Lingua',
    change_interface_language: 'Seleziona lingua interfaccia',
    change_infringment_language: 'Seleziona nazione infrazioni',
    change_timezone: 'Seleziona fuso orario',
    save_language_settings: 'Salva impostazioni lingua',
    select_view: 'Seleziona vista',
    select_fields_placeholder: 'Seleziona i campi da visualizzare',
    selected_field: 'Campo selezionato',
    selected_fields: 'Campi selezionati',
    list: 'Lista',
    table: 'Tabella',
    view_options: 'Opzioni vista',
    fluid_table: 'Larghezza dinamica',
    fluid_table_descr:
        'Estendi la tabella a tutta la larghezza disponibile, distribuendola tra le colonne selezionate',
    nearest_city: 'Città più vicina',
    no_columns_selected: 'Nessuna colonna selezionata',
    actions: 'Azioni',
    sort_column: 'Ordina per questa colonna',
    move_column: 'Sposta colonna',
    hide_column: 'Nascondi colonna',
    show_all: 'Mostra tutte',
    load_failed_retry: 'Caricamento non riuscito, clicca per riprovare',
    hide_all: 'Nascondi tutte',
    columns_order: 'Ordine delle colonne',
    reset_columns: 'Ripristina predefinite',
    vehicle_fields_list: 'Quali informazioni vuoi che compaiano per ogni veicolo? (Max 3)',
    vehicle_fields_list_warning:
        'Attenzione: il campo non verrà visualizzato se non è disponibile per il veicolo',
    vehicle_identification: 'Come vuoi che il veicolo venga identificato nella lista principale?',
    apply_to_marker: 'Applica questa impostazione anche ai veicoli su mappa',
    element_icon_section: 'Icona elemento',
    element_title_section: 'Titolo elemento',
    element_fields_list_section: 'Lista campi elemento',
    element_icon_description: "Seleziona l'icona da visualizzare per l'elemento",
    element_icon: 'Icona',
    element_icon_color: 'Colore icona',
    options_map: 'Opzioni mappa',
    vehicles_clustering: 'Raggruppamento dei veicoli',
    vehicles_clustering_warning: 'Aggiornare questa impostazione richiede di ricaricare la pagina',
    options_marker: 'Opzioni marker',
    size: 'Dimensione',
    font_size: 'Dimensione testo',
    font_color: 'Colore testo',
    background_color: 'Colore sfondo',
    opacity: 'Trasparenza',
    color: 'Colore',
    small: 'Piccolo',
    medium: 'Medio',
    large: 'Grande',
    additional_info: 'Informazioni aggiuntive',
    add_marker_data: 'Seleziona i dati da visualizzare',
    remove: 'Rimuovi',
    move_up: 'Sposta su',
    move_down: 'Sposta giù',
    analysis_options: 'Analisi percorso',
    options_chart: 'Opzioni grafico',
    options_timeline: 'Opzioni timeline',
    hide_timeline: 'Nascondi timeline',
    bind_colors: 'Associa colori',

    // Other
    map: 'Mappa',
    silica: 'Silica',
    google: 'Google',
    google_satellite: 'Google Satellitare',
    sandbox: 'Sandbox',
    silkysand: 'Silkysand',
    gravelpit: 'Gravelpit',
    open_street_maps: 'Open Street Maps',
    arcgis_satellite: 'ArcGIS Satellite',
    traffic: 'Traffico',
    traffic_anomalies: 'Incidenti e anomalie',
    heavy_vehicles_ban: 'Divieti veicoli pesanti',
    driver: 'Autista',
    no_driver: 'Nessun autista',
    drivers: 'Autisti',
    driver_card: 'Carta autista',
    name: 'Nome',
    surname: 'Cognome',
    driver_activity: 'Attività autista',
    driver_status: 'Stato autista',
    drivers_statuses: 'Stati autista',
    activity_type: 'Tipo di attività',
    activity: 'Attività',
    no_activity: 'Nessuna attività',
    driver_at_rest: 'Autista a riposo',
    driver_available: 'Autista in disponibilità',
    driver_at_work: 'Autista al lavoro',
    driver_driving: 'Autista in guida',
    inactive_vehicle: 'Veicolo inattivo',
    last_driver_detected: 'Ultimo autista rilevato',
    rest: 'Riposo',
    work: 'Lavoro',
    driving: 'Guida',
    availability: 'Disponibilità',
    codriving: 'Guida in equipaggio',
    codriver: 'Equipaggio',
    break: 'Pausa sessione',
    daily_rest: 'Riposo giornaliero',
    violation: 'Violazione',
    to_begin_within: 'Da iniziare entro',
    to_end_within: 'Da terminare entro',
    after_total_time_travel: 'Dopo un totale di viaggio di',
    after_total_distance_travel: 'Dopo una totale di distanza percorsa di',
    residual_commitment_type: 'Tipo di impegno residuo',
    residual_commitment: 'Impegno residuo',
    commitment_hours: 'Ore di impegno',
    commitment_hours_description:
        'Trova tutti i veicoli i cui autisti hanno un impegno residuo superiore a quello indicato',
    driver_plafond: 'Plafond autista',
    residual_driving: 'Guida residua',
    residual_bonuses: 'Bonus residui',
    consider_bonuses: 'Il tempo viene calcolato considerando i bonus residui',
    current_activity: 'Attività corrente',
    next_activity: 'Prossima attività',
    view_plafond_detail: 'Visualizza dettaglio plafond',
    view_infringements: 'Visualizza infrazioni',
    view_tachograph_activities: 'Visualizza attività cronotachigrafo',
    card: 'Carta',
    driver_change: 'Cambio autista',
    shared_links: 'Link condivisi',
    gf: 'POI Rilevati',
    analyze: 'Analizza',
    plan: 'Pianifica',
    vehicle: 'Veicolo',
    vehicles: 'Veicoli',
    vehicle_info: 'Informazioni veicolo',
    vehicle_type: 'Tipo veicolo',
    vehicle_body: 'Corpo veicolo',
    truck_status: 'Stato veicolo',
    brand: 'Marca',
    model: 'Modello',
    no_card: 'Carta non inserita',
    no_card_driving: 'Guida senza carta',
    speed: 'Velocità',
    tacho_speed: 'Velocità (tachigrafo)',
    vehicle_hooked: 'Veicolo agganciato',
    truck_hooked_text: 'Questo veicolo è agganciato al seguente rimorchio: ',
    trailer_hooked_text: 'Questo rimorchio è agganciato al seguente veicolo: ',
    no_driver_rfid_info: "La carta conducente non è registrata nell'anagrafica autisti",
    gps_speed: 'Velocità (GPS)',
    level: 'Livello',
    battery: 'Batteria',
    low_battery_level: 'Livello batteria basso',
    fuel: 'Carburante',
    fuel_level: 'Livello carburante',
    low_fuel_level: 'Carburante scarso',
    consumption: 'Consumo',
    consumptions: 'Consumi',
    fuel_consumption: 'Consumo carburante',
    fuel_avg_consumption: 'Media consumo carburante giornaliera',
    altitude: 'Altitudine',
    weight: 'Peso',
    lastpoint_weight: 'Peso (ultimo punto)',
    vehicle_weight: 'Peso (t)',
    vehicle_length: 'Lunghezza (m)',
    vehicle_width: 'Larghezza (m)',
    vehicle_height: 'Altezza (m)',
    odometer: 'Odometro',
    odometer_tacho: 'Odometro (tachigrafo)',
    odometer_gps: 'Odometro (GPS)',
    gps_odometer: 'Odometro (GPS)',
    last_point: 'Ultimo punto',
    moving: 'In movimento',
    stopped: 'Fermo',
    engine_on: 'Motore acceso',
    ignition: 'Quadro acceso',
    engine_off: 'Motore spento',
    engine_on_off: 'Accensione motore',
    ignition_on: 'Quadro acceso',
    ignition_off: 'Quadro spento',
    device: 'Dispositivo',
    plate: 'Targa',
    chassis: 'Telaio',
    status: 'Status',
    custom_id: 'Nome personalizzato',
    heading: 'Direzione',
    rpm_engine: 'Giri Motore',
    pto_active: 'PTO attivo',
    pto_state: 'Stato PTO',
    device_timestamp: 'Timestamp',
    info: 'Info',
    solar_day_report: 'Report giornata solare',
    telemetry: 'Telemetria',
    parameters: 'Parametri',
    engine_coolant_temp: 'Temperatura motore',
    engine_rpm: 'Giri motore',
    dallas_temp_1: 'Temperatura 1',
    dallas_temp_2: 'Temperatura 2',
    dallas_temp_id_1: 'ID Temperatura 1',
    dallas_temp_id_2: 'ID Temperatura 2',
    digital_input_1: 'Ingresso digitale 1',
    digital_input_2: 'Ingresso digitale 2',
    digital_input_3: 'Ingresso digitale 3',
    digital_input_4: 'Ingresso digitale 4',
    digital_input_5: 'Ingresso digitale 5',
    battery_level: 'Livello batteria',
    adblue_liters: 'Litri Adblue',
    adblue_level: 'Livello Adblue',
    gnss_status: 'Stato GNSS',
    gnss_status_values: [
        'Spento',
        'Accesa, assenza GPS',
        'Accesa, assenza di satelliti',
        'Accesa, con satelliti',
        'Accesa, in sleep',
        'Stato di protezione'
    ],
    gnss_off: 'GNSS spento',
    gnss_on_fix: 'GNSS acceso, con satelliti',
    gnss_on_without_fix: 'GNSS acceso, assenza di satelliti',
    gnss_on_sleep: 'GNSS acceso, in sleep',
    gnss_on_protection: 'GNSS acceso, stato di protezione',
    gsm_signal: 'Segnale GSM',
    tacho_source: 'Sorgente tachigrafo',
    external_voltage: 'Alimentazione',
    tacho_overspeed: 'Overspeed tachigrafo',
    no_points_title: 'Ultima attività da più di 24 ore',
    no_points: 'Questo veicolo non manda punti da più di 24 ore',
    clutch: 'Frizione',
    clutch_switch: 'Interruttore frizione',
    brake_pedal: 'Pedale freno',
    accelerator_pedal: 'Pedale acceleratore',
    pedal_released: 'Pedale rilasciato',
    pedal_pressed: 'Pedale premuto',
    data_mode: 'Modalità dati',
    home_stop: 'Fermo in sede',
    home_moving: 'In movimento in sede',
    roaming_stop: 'Fermo in roaming',
    roaming_moving: 'In movimento in roaming',
    unknown_stop: 'Fermo sconosciuto',
    unknown_moving: 'In movimento sconosciuto',
    engine_coolant_temperature: 'Temperatura liquido raffreddamento',
    engine_temperature: 'Temperatura motore',
    cruise_control_active: 'Cruise control attivo',
    adblue_off: 'Adblue spento',
    adblue_red: 'Adblue rosso',
    adblue_yellow: 'Adblue giallo',
    adblue_info: 'Adblue info',
    charger_notconnected: 'Caricatore non collegato',
    charger_connected: 'Caricatore collegato',
    tacho_unknown: 'Sconosciuto',
    tacho_kline: 'K-Line',
    tacho_allcan: 'BUS-CAN',
    tacho_can: 'BUS-CAN',
    tacho_fms: 'FMS',
    lock_command: 'Blocco accensione',
    vehicle_not_found: 'Il veicolo a cui stai tentando di accedere non è disponibile',
    vehicle_with_lock_commands: 'Veicolo con comandi di blocco',
    lock: 'Blocca',
    unlock: 'Sblocca',
    send: 'Invia',
    command_sent: 'Comando inviato con successo',
    turn_on: 'Attiva',
    turned_on: 'Attivo',
    turn_off: 'Disattiva',
    turned_off: 'Disattivo',
    confirm_send_command: 'Confermi di voler inviare il comando?',
    temperature: {
        title: 'Sonde temperatura',
        probe: ['Sonda 1', 'Sonda 2', 'Sonda 3', 'Sonda 4', 'Sonda 5', 'Sonda 6']
    },
    no_power_supply: 'Alimentazione assente',
    no_gps: 'GPS assente',
    tacho_clock_from_updated_error: 'Errore sincronizzazione orologio del tachigrafo',
    tacho_clock_from_device_error: 'Errore sincronizzazione tra tachigrafo e centralina',
    device_timestamp_error: 'Errore data centralina',
    select_color_mode: 'Seleziona modalità colore',
    light_mode: 'Modalità chiara',
    dark_mode: 'Modalità scura',
    color_blind_mode: 'Modalità daltonici',
    color_blind_dark_mode: 'Modalità scura daltonici',
    authorized: 'Autorizzato',
    logged_out: 'Uscito',
    last_hooked_trailer: 'Ultimo rimorchio agganciato',
    geofleet: {
        mainpanel: {
            pinned_vehicles: 'Veicoli in evidenza',
            search_trucks_title: 'Cerca veicoli',
            search_trucks_tags_title: 'Tag associati',
            search_trucks_status_title: 'Attività veicolo',
            search_trucks_driver_status_title: 'Attività autista',
            search_near_trucks_title: 'Trova veicoli vicini'
        },
        detailspanel: {
            bind_vehicle: 'Associa veicolo',
            add_new_tag: 'Aggiungi come nuovo tag',
            select_new_tag: 'Seleziona o cerca un tag',
            binded_tags: 'Tag associati',
            binded_tag: 'Tag associato'
        },
        analyzer: {
            vehicle_activity_analisys: 'Analisi attività veicolo',
            timeline_separator: 'Raggruppa per',
            loading_error: 'Si è verificato un errore durante il caricamento dei dati'
        },
        search_resources: {
            title: 'Cerca risorse',
            description:
                'Trova le stazioni di rifornimento, i parcheggi e le aree raggiungibili più vicine al tuo veicolo.'
        }
    },
    analisys: {
        title: 'Analisi percorso',
        select_telemetries: "Seleziona le telemetrie da visualizzare nell'analisi percorso",
        select_telemetries_description:
            "E' possibile selezionare un massimo di 4 telemetrie da visualizzare",
        chart_settings: 'Impostazioni grafico',
        map_settings: 'Impostazioni mappa',
        select_telemetries_map: 'Seleziona le telemetrie da visualizzare sulla mappa',
        select_telemetries_map_description:
            'Queste telemetrie vengono mostrate nel popup di ogni punto del percorso',
        accumulated_data_hint:
            "Quando attive, ognuna di queste impostazioni accumula il proprio valore dall'inizio del percorso fino al punto selezionato",
        chart_groups: {
            movement_data: 'Dati di movimento',
            engine_data: 'Dati motore',
            vehicle_data: 'Dati veicolo',
            sensors_data: 'Dati sensori',
            driver_data: 'Dati autista',
            fuel_data: 'Dati carburante',
            accumulated_data: 'Dati cumulati'
        },
        no_data: 'Nessun dato disponibile',
        no_data_description:
            'Non ci sono dati di percorso da visualizzare per questo veicolo o per il periodo selezionato',
        no_data_contact_support: 'Contatta il supporto clienti per ulteriori informazioni',
        stop_vehicle_minutes_separator: 'Tempo minimo di sosta',
        stopped_vehicle: 'Veicolo fermo'
    },
    planner: {
        user_config: 'Configurazioni utente',
        no_user_config: 'Non ci sono configurazioni utente da visualizzare',
        freight_access: 'Accesso alle borse carico',
        vehicle_actual_position: 'Posizione attuale veicolo',
        plan_route: 'Pianifica percorso',
        select_on_map: 'Seleziona un punto sulla mappa',
        select_on_map_option: 'Seleziona sulla mappa',
        fill_route_info: 'Compila le informazioni del percorso',
        fill_resources: 'Seleziona il punto da aggiungere come tappa',
        fill_waypoints: 'Seleziona le tappe',
        load_breaks: 'Carica le pause',
        load_alternative_routes: 'Carica percorsi alternativi',
        savedroutes: {
            my_routes: 'I miei percorsi',
            saved_routes: 'Percorsi salvati',
            no_saved_routes: 'Non hai ancora salvato nessun percorso',
            success_saved_route: 'Il tuo percorso è stato salvato con successo',
            error_saved_route: 'Si è verificato un errore durante il salvataggio del percorso',
            success_deleted_route: 'Il tuo percorso è stato eliminato con successo',
            error_deleted_route: "Si è verificato un errore durante l'eliminazione del percorso"
        },
        resources: {
            area_search: 'Cerca nel raggio di',
            station_services: 'Comprensivi di questi servizi',
            parking_services: 'Servizi parcheggio',
            select_rating: 'Seleziona il punteggio',
            select_security: 'Seleziona la sicurezza',
            empty_search: 'La ricerca non ha trovato alcun elemento da mostrare',
            delivery_nation: 'Nazione di consegna',
            fai_featured: 'Convenzionato Lumesia',
            self_service: 'Self Service',
            served: 'Servito',
            total_parking_spots: 'Totale posti',
            rating: 'Rateo',
            reviews: 'Recensioni',
            security: 'Sicurezza',
            price_per_night: 'Prezzo per notte'
        },
        emissions_labels: 'Emissioni',
        emissions: {
            fuelconsumption: 'Consumo carburante',
            hydrocarbons: 'Idrocarburi',
            methane: 'Metano',
            hydrocarbonsexceptmethane: 'Idrocarburi eccetto metano',
            carbonmonoxide: 'Monossido di carbonio',
            carbondioxide: 'Diossido di carbonio',
            fossilcarbondioxide: 'Diossido di carbonio fossile',
            sulphurdioxide: 'Diossido di zolfo',
            nitrogenoxides: 'Ossidi di azoto',
            nitrogendioxide: 'Diossido di azoto',
            nitrousoxide: 'Ossido nitroso',
            ammonia: 'Ammoniaca',
            benzene: 'Benzene',
            particles: 'Particelle',
            numberofparticles: 'Numero di particelle'
        },
        plafond_configuration: {
            title: 'Configurazione plafond',
            driving_time_regulation: 'Tempo di guida',
            last_time_the_driver_worked: 'Ultima attività autista',
            eu_driving_time_regulation_for_single_day: 'Singolo giorno',
            eu_driving_time_regulation_for_single_long_day: 'Singolo giorno (con bonus)',
            eu_driving_time_regulation_for_multiple_day: 'Più giorni',
            eu_driving_time_regulation_for_team_and_multiple_day: 'Più giorni (con equipaggio)',
            accumulated_driving_time_since_lastbreak: "Ore di guida dall'ultima pausa",
            accumulated_driving_time_since_lastdailyrest:
                "Ore di guida dall'ultimo riposo giornaliero",
            accumulated_travel_time_since_lastdailyrest:
                "Ore di viaggio dall'ultimo riposo giornaliero"
        },
        set_route: 'Imposta percorso',
        select_profile: 'Seleziona profilo',
        select_co2_class: 'Seleziona classe di emissioni',
        class: 'Classe',
        billed_roads: 'Strade a pagamento',
        waypointevent: 'Tappa',
        waypoints_label: 'Tappe',
        add_waypoint: 'Aggiungi tappa',
        delete_waypoint: 'Elimina tappa',
        select_waypoint: 'Seleziona tappa',
        select_resource: 'Seleziona il punto da aggiungere come tappa',
        last_waypoint: 'Ultima tappa',
        waypoints_check: 'Ci sono delle tappe da completare',
        waypoints_required: 'Sono necessarie almeno 2 tappe',
        countryevent: 'Stato',
        tollevent: 'Casello',
        event: 'Evento',
        alpega: 'Alpega',
        alpega_login: 'Login Alpega',
        alpega_searches: 'Le tue ricerche',
        timocom: 'Timocom',
        pickup: 'Ritiro',
        delivery: 'Consegna',
        extimated_cost: 'Costo stimato',
        calculate_route: 'Calcola percorso',
        calculate_isocrona: 'Calcola isocrona',
        complete_step_2: 'Completa lo step 2',
        reset_route: 'Nuovo percorso',
        route_error: 'Si è verificato un errore durante il calcolo del percorso',
        edit_route: 'Modifica percorso',
        save_route: 'Salva percorso',
        delete_route: 'Elimina percorso',
        route_name: 'Nome percorso',
        override_route: 'Sovrascrivi percorso',
        save_as_new_route: 'Salva nuovo percorso',
        calculate_route_for: 'Calcola percorso per',
        ptvexport: 'Esporta in PTV Navigator',
        isocrona: 'Aree raggiungibili',
        reset_isocrona: 'Resetta aree raggiungibili',
        search_location: 'Cerca località',
        search_station: 'Cerca distributore',
        search_parking: 'Cerca parcheggio',
        search_poi: 'Cerca POI',
        include_plafond: 'Includi plafond autista nel calcolo del percorso',
        include_plafond_near_vehicles:
            'Trova i veicoli con autisti aventi un impegno residuo sufficiente ad arrivare alla località cercata',
        violated_plafond: "Il percorso selezionato viola il plafond dell'autista"
    },
    sharedlinks: {
        back_to_links: 'Torna ai link',
        create_link: 'Crea link',
        update_link: 'Aggiorna link',
        edit_link: 'Modifica link',
        update_link_expire_date: 'Aggiorna data di scadenza',
        delete_link: 'Elimina link',
        delete_link_confirm: 'Eliminare il link selezionato?',
        all_your_shared_links: 'Tutti i tuoi link condivisi',
        no_shared_links: 'Non hai ancora condiviso nessun veicolo',
        vehicles_link: 'Link per i veicoli',
        select_share_vehicles: 'Seleziona veicoli da condividere',
        select_start_expire_date: 'Seleziona data di inizio e di scadenza',
        created_link_error: 'Errore durante la creazione del link',
        created_link_success: 'Link creato con successo',
        updated_link_error: "Errore durante l'aggiornamento del link",
        updated_link_success: 'Link aggiornato con successo',
        service_description:
            'Condividi questo link per mostrare il tracciamento dei veicoli selezionati',
        link_preview: 'Anteprima del link',
        share_single_vehicle: 'Condividi la posizione di questo veicolo',
        track_vehicle_position: 'Traccia la posizione dei veicoli selezionati',
        start_date_warning: 'Non è possibile modificare la data di inizio',
        start_date_condition: 'Se vuoi modificare la data di inizio, devi creare un nuovo link',
        expire_date_description:
            'Indica una data di scadenza, oltre il quale questo link non sarà più disponibile',
        start_expire_date_description:
            'Indica una data di iniziale, a partire dal quale questo link sarà disponibile, e una data di scadenza, oltre il quale questo link non sarà più disponibile:'
    },
    viewsharedlink: {
        invalid_date_range: 'Il range di date che hai selezionato non è valido per questo link',
        too_early_link: 'Il link a cui stai tentando di accedere non è ancora diponibile',
        too_late_link: 'Il link a cui stai tentando di accedere non esiste più',
        show_route: 'Mostra percorso'
    },
    tags: {
        manage_tags: 'Gestisci tags',
        add_tag: 'Aggiungi tag',
        add_tag_placeholder: 'Inserisci il nome del tag',
        add_tag_error: "Errore durante l'aggiunta del tag",
        add_tag_success: 'Tag aggiunto con successo',
        delete_tag: 'Elimina tag',
        delete_tag_confirm: 'Eliminare il tag selezionato?',
        delete_tag_error: "Errore durante l'eliminazione del tag",
        delete_tag_success: 'Tag eliminato con successo',
        update_tag: 'Aggiorna tag',
        update_tag_error: "Errore durante l'aggiornamento del tag",
        update_tag_success: 'Tag aggiornato con successo',
        all_your_tags: 'Tutti i tuoi tag',
        no_tags: 'Non hai ancora creato nessun tag',
        tag_name: 'Nome tag'
    },
    manage_poi: {
        title: 'Gestisci POI',
        your_pois: 'I tuoi POI',
        add_poi: 'Aggiungi POI',
        no_pois: 'Non hai ancora creato nessun POI',
        fields: {
            name: 'Nome',
            type: 'Tipo',
            color: 'Colore',
            note: 'Note',
            address: 'Cerca indirizzo',
            latitude: 'Latitudine',
            longitude: 'Longitudine',
            radius: 'Raggio di ricerca',
            radius_description: 'Per abilitare il geofencing impostare un valore maggiore di zero',
            area_type: 'Tipo di area',
            area_type_circle: 'Cerchio (centro + raggio)',
            area_type_polygon: 'Poligono',
            polygon_description:
                "Disegna un poligono sulla mappa per definire l'area di geofencing."
        },
        types_poi: {
            all: 'Tutti',
            headquarter: 'Sede',
            truck_washes: 'Autolavaggi autotreni',
            blacklist: 'Blacklist',
            end_of_the_line: 'Capolinea',
            customers: 'Clienti',
            stops: 'Fermate',
            suppliers: 'Fornitori',
            interports: 'Interporti',
            markets: 'Mercati',
            large_square: 'Piazzali',
            poi_distributors: 'POI Distributori',
            poi_workshops: 'POI Officine',
            harbors: 'Porti',
            restaurants: 'Ristoranti',
            stations: 'Stazioni'
        },
        alert_types: {
            in: 'Entrata',
            out: 'Uscita',
            both: 'Entrata e Uscita'
        },
        notifications: {
            enabled: 'Notifiche attivate',
            disabled: 'Notifiche disattivate',
            add_email: 'Aggiungi email',
            settings_title: 'Impostazioni notifiche POI',
            email_addresses: 'Configura qui gli indirizzi email da notificare',
            insert: 'Inserisci un indirizzo email'
        },
        messages: {
            add_poi_error: "Errore durante l'aggiunta del POI",
            add_poi_success: 'POI aggiunto con successo',
            update_poi_error: "Errore durante l'aggiornamento del POI",
            update_poi_success: 'POI aggiornato con successo',
            delete_poi_error: "Errore durante l'eliminazione del POI",
            delete_poi_success: 'POI eliminato con successo',
            delete_poi_confirm: 'Eliminare il POI selezionato?',
            create_poi_notification_success: 'Notifiche POI create con successo',
            update_poi_notification_success: 'Notifiche POI aggiornate con successo',
            create_poi_notification_error: 'Errore durante la creazione delle notifiche POI',
            update_poi_notification_error: "Errore durante l'aggiornamento delle notifiche POI",
            delete_poi_notification_error: "Errore durante l'eliminazione delle notifiche POI",
            delete_poi_notification_success: 'Notifiche POI eliminate con successo',
            delete_poi_notification_confirm: 'Eliminare le notifiche del POI selezionato?',
            add_emails_success: 'Emails aggiunte con successo',
            add_emails_error: "Errore durante l'aggiunta degli emails",
            invalid_polygon: 'Il poligono disegnato non è valido, seleziona almeno 3 punti.'
        },
        categories: {
            title: 'Categorie POI',
            subtitle: 'Gestisci le categorie dei tuoi POI',
            description: 'Descrizione',
            color: 'Colore',
            add_category: 'Aggiungi categoria',
            add_category_placeholder: 'Inserisci il nome della categoria',
            icon: 'Icona',
            cancel: 'Annulla',
            update_category: 'Aggiorna categoria',
            choose_icon: "Scegli un'icona",
            no_icons: 'Non ci sono icone disponibili',
            search_icon: 'Cerca icona per nome o codice',
            actions: 'Azioni',
            scope: 'Tipologia'
        }
    },
    vehicles_cross: {
        title: 'Passaggio veicoli',
        fields: {
            address: 'Indirizzo',
            radius: 'Raggio',
            time_interval: 'Intervallo di tempo',
            time_interval_description: 'Seleziona un intervallo di tempo massimo di 24 ore'
        },
        messages: {
            max_time_interval: "L'intervallo di tempo massimo è di 24 ore",
            error_searching: 'Si è verificato un errore durante la ricerca dei veicoli',
            searching: 'Ricerca in corso...',
            long_loading: 'La ricerca potrebbe richiedere alcuni minuti, attendere prego...',
            no_vehicles_cross: 'Nessun veicolo trovato'
        }
    },
    plafonds: {
        session: 'Pausa di sessione',
        break: 'Pausa',
        drive_occurring: "E' in corso un Periodo di Guida:",
        drive_max_label: 'Tempo massimo di guida',
        drive_max_value: '4h 30m',
        drive_done: 'Guida effettuata',
        session_title: 'Informazioni sulla Pausa Frazionata',
        session_tooltip: "E' possibile effettuare una Pausa Frazionata",
        session_done: "E' stata rilevata una pausa di almeno 15 minuti.",
        session_info: 'Già effettuata la prima parte di una Pausa Frazionata',
        session_descr:
            "Ricordiamo che per le vigenti normative è possibile effettuare una pausa di 15'+30' o di 15'+15'+15' (in base al tipo di trasporto effettuato).",
        session_choice:
            "Trasporto merci e persone: è possibile effettuare un'interruzione di almeno 30 minuti. Servizio occasionale passeggeri: l'interruzione di 45 minuti può essere sostituita da due interruzioni di almeno 15 minuti ciascuna.",
        brake_start: 'Inizio pausa',
        brake_done: 'Pausa effettuata',
        daily: 'Giornaliera',
        weekly: 'Settimanale',
        driver_in_drive: 'Tempo di guida di oggi',
        driver_in_rest: 'Riposo residuo',
        driver_in_work: 'Lavoro',
        driver_in_available: 'Disponibilità',
        driver_in_availability: 'Disponibilità',
        current_activity: 'Attività corrente',
        mini_plafond: 'Mini-Plafond',
        last_update: 'Ultimo aggiornamento',
        panel_title: 'Pannello Plafond',
        residual_commitment: 'Impegno residuo',
        daily_driving: 'Guida giornaliera',
        driving_to_next_break: 'Guida alla prossima pausa',
        weekly_guide: 'Guida settimanale',
        biweekly_guide: 'Guida bi-settimanale',
        last_rest: 'Ultimo riposo settimanale effettuato',
        minimal_duration_next: 'Durata minima prossimo',
        top_start_until: 'Da iniziare entro il',
        reduced_weekly_rest: 'Riposi settimanali ridotti da compensare',
        time_to_compensate: 'Tempo da compensare',
        time_to_compensate_until: 'Da compensare entro il',
        footer_message: '* il tempo viene calcolato considerando i bonus residui',
        driver_in_block: 'Plafond autista esaurito'
    },
    error_pages: {
        error_403: {
            title: 'Errore 403',
            description:
                'Gentile cliente, ti informiamo che la tua utenza non è attualmente configurata per accedere a questo servizio. Per ricevere informazioni sul servizio stesso',
            retry_login: "Riprova l'accesso",
            contact_us: 'Contattaci'
        }
    },
    ptv: {
        maxpermittedweight: 'Peso massimo',
        minpermittedweight: 'Peso minimo',
        zonename: 'Zona',
        unauthorizedtype: 'Codice non autorizzato',
        maxemissionstandardeu: 'Classe di emissione',
        fueltype: 'Tipo carburante',
        loadtype: 'Tipo di trasporto',
        opening: 'Passaggio',
        maxheight: 'Altezza massima',
        maxweight: 'Peso massimo',
        maxwidth: 'Larghezza massima',
        maxlength: 'Lunghezza massima',
        absolutespeed: 'Velocità',
        hazardoustowaters: "Divieto per veicoli con merce pericolosa per l'acqua",
        hazardousgoods: 'Divieto per veicoli con merce pericolosa',
        combustibles: 'Divieto per veicoli che trasportano carburante',
        maxaxleload: 'Peso massimo agli assi',
        totalpermittedweight: 'Peso massimo',
        tunnelrestriction: 'Codice restrizione tunnell',
        kingpintorearaxle: 'Distanza da kingpin a asse',
        numberofaxles: 'Numero di assi',
        length: 'Tratta',
        delay: 'Ritardo',
        message: {
            text: 'Messaggio'
        }
    },
    options_interface: 'Interfaccia delle opzioni',
    company_filters: {
        branches: 'Filiali',
        sectors: 'Settori'
    },
    freight_exchange: {
        title: 'Cerca borse carichi',
        golia_exchange_sync: 'Sincronizza con Golia Exchange',
        search_here: 'Cerca nella zona visualizzata',
        zoom_to_search: 'Aumenta lo zoom per effettuare la ricerca',
        filters: 'Filtri',
        spots: 'Posti',
        offers: 'Offerte',
        no_offers: 'Nessuna offerta disponibile',
        loading: 'Carico',
        unloading: 'Scarico',
        clear_offers: 'Elimina tutte le offerte',
        fields: {
            vehicle_type: 'Tipo di veicolo',
            vehicle_size: 'Dimensione del veicolo',
            weight_range_from: 'Peso minimo (t)',
            weight_range_to: 'Peso massimo (t)',
            date_range: 'Data di inizio e fine',
            destination: 'Destinazione',
            destination_radius: 'Raggio dalla destinazione',
            apply: 'Salva ricerca',
            reset: 'Resetta ricerca'
        },
        popup_key: {
            company: 'Azienda',
            vehicle: 'Tipo di veicolo',
            vehicle_size: 'Dimensione del veicolo',
            required_truck_bodies: 'Tipi di veicolo richiesti',
            distance: 'Distanza',
            pickup: 'Ritiro',
            delivery: 'Consegna',
            price: 'Prezzo',
            open_in_golia_exchange: 'Apri in Golia Exchange'
        },
        vehicle_type: {
            curtainside: 'Curtainside',
            cooler: 'Raffreddato',
            standard_tent: 'Tenda standard',
            box: 'Box',
            open_box: 'Box aperto',
            isotherm: 'Isotermo',
            meathanger: 'Meathanger',
            food_tanker: 'Serbatoio per cibo',
            tanker: 'Tanker',
            other: 'Altro',
            car_transporter: 'Autocarro',
            dump_truck: 'Dump truck',
            petroleum_tanker: 'Tanker per petrolio',
            chemical_tanker: 'Tanker per chimica',
            gas_tanker: 'Tanker per gas',
            silos: 'Silos',
            mega: 'Mega',
            coilmulde: 'Coilmulde',
            log_trailer: 'Trailer a log',
            platform_trailer: 'Piattaforma',
            hook_truck: 'Veicolo con trattore',
            low_loader: 'Carrello elevatore',
            truck: 'Autocarro',
            swap_body_system: 'Sistema di scambio del corpo',
            '20_standard': '20 standard',
            '40_standard': '40 standard',
            '45_standard': '45 standard',
            joloda: 'Joloda',
            bde: 'BDE',
            walkingfloor: 'Pavimentatore',
            tank_body_20: 'Serbatoio 20',
            tank_body_40: 'Serbatoio 40',
            jumbo: 'Jumbo'
        },
        vehicle_size: {
            solo: 'Veicolo singolo',
            lorry: 'Autocarro',
            double_trailer: 'Trailer doppio',
            any_size: 'Dimensione qualsiasi',
            bus: 'Autobus'
        }
    },
    settings_section: {
        address: {
            address_settings: 'Impostazioni indirizzo',
            available_elements: 'Elementi disponibili',
            address_composition: 'Composizione indirizzo',
            drag_and_reorder_items: 'Trascina e riordina gli elementi',
            preview: 'Anteprima',
            click_to_fetch:
                "Clicca su un punto qualsiasi per ottenere il geocoding inverso e visualizzare l'anteprima dell'output configurato.",
            coordinates: 'Coordinate',
            result: 'Risultato',
            info_preview:
                'Le pillole verdi rappresentano i campi mappati nel punto selezionato, quelle rosse i campi non mappati nel punto selezionato. Passando con il mouse sopra ogni pillola è possibile visualizzare il nome del campo corrispondente se presente.',
            elements: {
                city: 'Citta',
                country: 'Nazione',
                country_code: 'Codice nazione',
                county: 'Circoscrizione',
                hamlet: 'Frazione',
                municipality: 'Municipalità',
                postcode: 'CAP',
                road: 'Via',
                state: 'Stato',
                suburb: 'Sobborgo',
                town: 'Comune',
                village: 'Paese'
            }
        },
        map: {
            additional_data: {
                driver_full_name: 'Nome completo autista',
                custom_code: 'Codice personalizzato'
            }
        }
    }
}
